// src/utils/gtm/cacheData.js

const DB_NAME = 'GtmDataCache';
const STORE_NAME = 'gtmData';
const DB_VERSION = 1;

// Open IndexedDB
const openDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        
        request.onerror = () => {
            console.error('[GTM Data Cache]: Error opening IndexedDB');
            reject(request.error);
        };
        
        request.onsuccess = () => {
            resolve(request.result);
        };
        
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };
    });
};

// Use IndexedDB to cache data
export const cacheData = async (key, data) => {
    try {
        const db = await openDB();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        await store.put(data, key);
    } catch (err) {
        console.error(`[GTM Data Cache]: Error caching ${key} data:`, err);
    }
};

// Get cached data
export const getCachedData = async (key) => {
    try {
        const db = await openDB();
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        return await store.get(key);
    } catch (err) {
        console.error(`[GTM Data Cache]: Error retrieving cached ${key} data:`, err);
        return null;
    }
};

// Clear cached data
export const clearCachedData = async (key) => {
    try {
        const db = await openDB();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        await store.delete(key);
    } catch (err) {
        console.error(`[GTM Data Cache]: Error clearing cached ${key} data:`, err);
    }
};
